export default __webpack_public_path__ + "static/media/03__o_5.12e35b68.jpg";